import './index.scss';



/** WEBPACK FOOTER **
 ** ./src/Home/index.js
 **/